export default __webpack_public_path__ + "static/media/teilor-logo.764fb890.svg";